import messages from './messages';

const schema = ({ intl }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultFieldset),
      fields: [
        'eyebrow',
        'title',
        'count_label',
        'show_allergen_notice',
        'subcategories',
      ],
    },
  ],
  properties: {
    eyebrow: {
      title: intl.formatMessage(messages.eyebrow),
      type: 'string',
      default: intl.formatMessage(messages.defaultEyebrow),
    },
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
      default: intl.formatMessage(messages.defaultTitle),
    },
    count_label: {
      title: intl.formatMessage(messages.countLabel),
      type: 'string',
      default: intl.formatMessage(messages.defaultCountLabel),
    },
    show_allergen_notice: {
      title: intl.formatMessage(messages.showAllergenNotice),
      type: 'boolean',
    },
    subcategories: {
      title: intl.formatMessage(messages.subcategories),
      type: 'array',
      widget: 'object_list',
      schema: {
        title: intl.formatMessage(messages.categoryTitle),
        addMessage: intl.formatMessage(messages.addCategory),
        fieldsets: [
          {
            id: 'default',
            title: intl.formatMessage(messages.categoryTitle),
            fields: ['title', 'full_width', 'image', 'items'],
          },
        ],
        properties: {
          title: { title: intl.formatMessage(messages.title), type: 'string' },
          full_width: {
            title: intl.formatMessage(messages.fullWidth),
            type: 'boolean',
          },
          image: {
            title: intl.formatMessage(messages.image),
            type: 'string',
            widget: 'object_browser',
            mode: 'image',
            description: intl.formatMessage(messages.imageDescription),
          },
          items: {
            title: intl.formatMessage(messages.items),
            type: 'array',
            widget: 'object_list',
            schema: {
              title: intl.formatMessage(messages.drinkTitle),
              addMessage: intl.formatMessage(messages.addDrink),
              fieldsets: [
                {
                  id: 'default',
                  title: intl.formatMessage(messages.drinkTitle),
                  fields: ['name', 'price', 'subtitle'],
                },
              ],
              properties: {
                name: {
                  title: intl.formatMessage(messages.name),
                  type: 'string',
                },
                price: {
                  title: intl.formatMessage(messages.price),
                  type: 'string',
                },
                subtitle: {
                  title: intl.formatMessage(messages.subtitle),
                  type: 'string',
                },
              },
            },
          },
        },
      },
    },
  },
  required: [],
});

export default schema;
